import { DefaultOptionType } from 'antd/es/select';

import { DocTypeEnum, PageTypeEnum } from './common.constant';

export enum IssuanceApplicationEnum {
	IA1 = 'IA1',
	IA2 = 'IA2',
	IA3 = 'IA3',
	IA4 = 'IA4',
	IA5 = 'IA5',
	IA6 = 'IA6',
	IA7 = 'IA7',
	IA8 = 'IA8',
	IA9 = 'IA9',
	IA10 = 'IA10',
	IA11 = 'IA11',
	IA12 = 'IA12',
	IA13 = 'IA13',
	IA14 = 'IA14',
}

export enum DocumentTypeEnum {
	C_0 = 'C_0',
	C_1 = 'C_1',
	C_2 = 'C_2',
	C_3 = 'C_3',
	C_4 = 'C_4',
	C_5 = 'C_5',
	C_6 = 'C_6',
	C_7 = 'C_7',
	C_8 = 'C_8',
	C_9 = 'C_9',
	C_10 = 'C_10',
	C_11 = 'C_11',
	C_12 = 'C_12',
	C_13 = 'C_13',
	C_14 = 'C_14',
	// C_15 = 'C_15',
	C_16 = 'C_16',
	C_17 = 'C_17',
	C_18 = 'C_18',
	C_19 = 'C_19',
	C_20 = 'C_20',
	C_21 = 'C_21',
	C_22 = 'C_22',
	C_23 = 'C_23',
	C_24 = 'C_24',
	C_25 = 'C_25',
	C_26 = 'C_26',
	C_27 = 'C_27',
	C_28 = 'C_28',
	C_29 = 'C_29',
	C_30 = 'C_30',
	C_31 = 'C_31',
	C_32 = 'C_32',
	C_33 = 'C_33',
	C_34 = 'C_34',
	C_35 = 'C_35',
	C_36 = 'C_36',
	C_37 = 'C_37',
	C_38 = 'C_38',
	C_39 = 'C_39',
	C_40 = 'C_40',
	C_41 = 'C_41',
	C_42 = 'C_42',
	C_43 = 'C_43',
	C_44 = 'C_44',
	C_45 = 'C_45',
	C_46 = 'C_46',
	C_47 = 'C_47',
	C_48 = 'C_48',
	C_49 = 'C_49',
	C_50 = 'C_50',
	C_51 = 'C_51',
	C_52 = 'C_52',
	C_53 = 'C_53',
	C_54 = 'C_54',
	C_55 = 'C_55',
	C_56 = 'C_56',
	C_57 = 'C_57',
	C_58 = 'C_58',
	C_59 = 'C_59',
	C_60 = 'C_60',
	C_61 = 'C_61',
	C_62 = 'C_62',
	C_63 = 'C_63',
	C_64 = 'C_64',
	C_65 = 'C_65',
	C_66 = 'C_66',
	C_67 = 'C_67',
	C_68 = 'C_68',
	C_69 = 'C_69',
	C_71 = 'C_71', // for company seal
	C_72 = 'C_72', // for Consent to collection, use and provision of personal information
	C_73 = 'C_73', // for Consent to collection, use and provision of personal information
	C_74 = 'C_74',
	C_75 = 'C_75',
	C_76 = 'C_76',
	C_77 = 'C_77',
	// New Form
	C_78 = 'C_78',
	C_79 = 'C_79',
	C_80 = 'C_80',
	C_81 = 'C_81',
	C_82 = 'C_82',
	C_83 = 'C_83',
	C_84 = 'C_84',
}

export const MAPPING_DOC_TYPE = {
	[DocumentTypeEnum.C_3]: DocTypeEnum.PM1_04,
	[DocumentTypeEnum.C_4]: DocTypeEnum.PMF_02,
	[DocumentTypeEnum.C_13]: DocTypeEnum.AM1_08,
	[DocumentTypeEnum.C_14]: DocTypeEnum.WC1_13,
	// [DocumentTypeEnum.C_15]: DocTypeEnum.AM1_06,
	[DocumentTypeEnum.C_18]: DocTypeEnum.PM1_13,
	[DocumentTypeEnum.C_19]: DocTypeEnum.ES1_09,
	[DocumentTypeEnum.C_21]: DocTypeEnum.ES1_10,
	[DocumentTypeEnum.C_22]: DocTypeEnum.WC1_05,
	[DocumentTypeEnum.C_25]: DocTypeEnum.PM2_22,
	[DocumentTypeEnum.C_37]: DocTypeEnum.PM1_09,
	[DocumentTypeEnum.C_38]: DocTypeEnum.PM1_19,
	[DocumentTypeEnum.C_48]: DocTypeEnum.AM1_05,
	[DocumentTypeEnum.C_49]: DocTypeEnum.AM1_09,
	[DocumentTypeEnum.C_52]: DocTypeEnum.PM2_23,
	[DocumentTypeEnum.C_53]: DocTypeEnum.PM2_24,
	[DocumentTypeEnum.C_54]: DocTypeEnum.PM1_10,
	[DocumentTypeEnum.C_55]: DocTypeEnum.AM1_06,
	[DocumentTypeEnum.C_57]: DocTypeEnum.ES1_10,
	[DocumentTypeEnum.C_58]: DocTypeEnum.WCF_02,
	[DocumentTypeEnum.C_59]: DocTypeEnum.WC1_05,
	[DocumentTypeEnum.C_60]: DocTypeEnum.WC1_13,
	[DocumentTypeEnum.C_61]: DocTypeEnum.WC1_07,
	[DocumentTypeEnum.C_62]: DocTypeEnum.WC1_07,
	[DocumentTypeEnum.C_63]: DocTypeEnum.WC1_05,
	[DocumentTypeEnum.C_64]: DocTypeEnum.WC1_05,
	[DocumentTypeEnum.C_65]: DocTypeEnum.FRF_10,
	[DocumentTypeEnum.C_66]: DocTypeEnum.FRF_11,
	[DocumentTypeEnum.C_67]: DocTypeEnum.AFR_04,
	[DocumentTypeEnum.C_68]: DocTypeEnum.AFR_05,
	[DocumentTypeEnum.C_42]: DocTypeEnum.AFR_07,
	[DocumentTypeEnum.C_69]: DocTypeEnum.FRF_08,
	[DocumentTypeEnum.C_73]: DocTypeEnum.FRF_09,
	// [DocumentTypeEnum.C_24]: DocTypeEnum.FRF_04,
	[DocumentTypeEnum.C_16]: DocTypeEnum.LMF_04,
	[DocumentTypeEnum.C_72]: DocTypeEnum.ARF_08,
	[DocumentTypeEnum.C_74]: DocTypeEnum.ARF_09,
	[DocumentTypeEnum.C_75]: DocTypeEnum.WC1_05,
	[DocumentTypeEnum.C_76]: DocTypeEnum.FRF_12,
	[DocumentTypeEnum.C_77]: DocTypeEnum.ARF_10,
	[DocumentTypeEnum.C_78]: DocTypeEnum.ARF_11,
	[DocumentTypeEnum.C_79]: DocTypeEnum.ARF_12,
	[DocumentTypeEnum.C_80]: DocTypeEnum.FRF_13,
	[DocumentTypeEnum.C_81]: DocTypeEnum.ARF_13,
	[DocumentTypeEnum.C_82]: DocTypeEnum.ARF_14,
	[DocumentTypeEnum.C_83]: DocTypeEnum.ARF_15,
	[DocumentTypeEnum.C_84]: DocTypeEnum.ARF_16,
} as {
	[key in DocumentTypeEnum]: DocTypeEnum;
};

export type TDocumentOption = DefaultOptionType & {
	parents: PageTypeEnum[];
	hasDocument?: boolean;
	documents?: {
		[key in PageTypeEnum]: DocumentTypeEnum[];
	};
	labelEn?: string;
	// Override the displayed (Korean) label depending on which management
	// screen the option is shown on (e.g. 고용주용 vs 계절근로자용). Falls back
	// to `label` for page types not listed here.
	labelByPage?: Partial<Record<PageTypeEnum, string>>;
};

export const ALL_DOCUMENT_OPTIONS: TDocumentOption[] = [
	{
		value: DocumentTypeEnum.C_1,
		label: '내국인 구인노력입증 서류',
		labelEn: 'Documents Proving Efforts to Hire Domestic Workers',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_2,
		label: '국내 지자체의 자체 인센티브 부여기준',
		labelEn: 'Local Government Incentive Criteria (Domestic Policy)',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_3,
		label: '계절근로자 유치 계획서',
		labelEn: 'Seasonal Worker Recruitment Plan',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_4,
		label: '업무협약(MOU) 체결 결과서',
		labelEn: 'Results of the MOU Agreement',
		parents: [
			PageTypeEnum.UNIT,
			PageTypeEnum.PROGRAM,
			PageTypeEnum.RECOMMENDER,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_5,
		label: '공공형 계절근로 사업 계획서',
		labelEn: 'Public Seasonal Worker Project Plan',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_7,
		label: '업무분장표',
		labelEn: 'Task Distribution Table',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_8,
		label: '지자체 유치 신청 사전심사 결과',
		labelEn:
			'Preliminary Review Results for Local Government Recruitment Application',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_9,
		label: '계절근로자 감염병 격리 및 방역 계획서',
		labelEn: 'Seasonal Worker Quarantine and Disease Prevention Plan',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_10,
		label: '업무협약(MOU) 및 부속합의서',
		labelEn: 'Memorandum of Understanding (MOU) and Supplementary Agreement',
		parents: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_12,
		label: '농/어업경영체등록확인서',
		labelEn: 'Agriculture/Fishery Business Registration Certificate',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_13,
		label: '숙식비 공제 동의서',
		labelEn: 'Accommodation Expense Deduction Consent Form',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_14,
		label: '계절근로자 배치 대상 고용주 확인서',
		labelEn: 'Confirmation of Employer for Seasonal Worker Placement',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	// duplicate with C_55
	// {
	// 	value: DocumentTypeEnum.C_15,
	// 	label: '표준근로 계약서',
	// 	parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
	// 	hasDocument: true,
	// },
	{
		value: DocumentTypeEnum.C_16,
		label: '숙소시설표',
		labelEn: 'Accommodation Facility Checklist',
		parents: [
			PageTypeEnum.RECOMMENDER,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.LODGING,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_17,
		label: '산재보험 가입증명원',
		labelEn: 'Worker’s Compensation Insurance Certificate',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_18,
		label: '농/어업인 안전보험 가입 확약서',
		labelEn: 'Farmer/Fisherman Safety Insurance Enrollment Confirmation',
		parents: [PageTypeEnum.CHANGE_WORK_PLACE, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_19,
		label: '체류기간 연장 추천 신청서',
		labelEn: 'Stay Extension Recommendation Application',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_20,
		label: '고용주 신분증',
		labelEn: 'Employer Identification Document',
		parents: [
			PageTypeEnum.FRANCHISE,
			// PageTypeEnum.EXTENSION_STAY
		],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_21,
		label: '체류기간 만료 계절근로자 체류기간 연장 추천서',
		labelEn: 'Stay Extension Recommendation for Expiring Seasonal Workers',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_22,
		label: '고용변동신고서',
		labelEn: 'Employment Change Report',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_23,
		label: '건강보험 가입증명원',
		labelEn: 'Health Insurance Certificate',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: false,
	},
	// {
	// 	value: DocumentTypeEnum.C_24,
	// 	label: '계절근로자 재입국 추천서',
	// 	labelEn: 'Seasonal Worker Re-entry Recommendation Letter',
	// 	parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
	// 	hasDocument: true,
	// },
	{
		value: DocumentTypeEnum.C_25,
		label: '계절근로자 참여 확인서',
		labelEn: 'Seasonal Worker Participation Confirmation',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_26,
		label: '결혼이민자 신분증(외국인등록증 or 주민등록증)',
		labelEn:
			'Marriage Immigrant ID Card (Foreign Registration Card or Resident Registration Card)',
		parents: [PageTypeEnum.RECOMMENDER, PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_27,
		label: '혼인관계증명서',
		labelEn: 'Marriage Relationship Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_28,
		label: '기본증명서',
		labelEn: 'Basic Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_29,
		label: '결혼이민자의 친척 관계도',
		labelEn: 'Family Tree of the Marriage Immigrant',
		parents: [PageTypeEnum.RECOMMENDER, PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_30,
		label: '출생증명서',
		labelEn: 'Birth Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_31,
		label: '결혼증명서',
		labelEn: 'Marriage Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_32,
		label: '거주사실확인증명서',
		labelEn: 'Proof of Residence Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_33,
		label: '호적부',
		labelEn: 'Family Registry',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_34,
		label: '호구부',
		labelEn: 'Household Register',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_35,
		label: '친속관계공증서',
		labelEn: 'Kinship Notarization',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_36,
		label: '가족관계증명서',
		labelEn: 'Family Relationship Certificate',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_37,
		label: '계절근로 참여 신청서(결혼이민자의 가족·친척)',
		labelEn:
			'Application for Participation in Seasonal Work (Family and Relatives of Marriage Immigrants)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_38,
		label: '계절근로 참여 신청서(국내체류 외국인)',
		labelEn:
			'Application for Participation in Seasonal Work (Foreigners Staying in Korea)',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_39,
		label: '이력서(MOU, 본국 농/어업에 종사 내역 or 한국어 능력 관련)',
		labelEn:
			'Resume (MOU, History of Work in Agriculture/Fishery or Korea’s Competency Certification)',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_40,
		label: '여권 사본',
		labelEn: 'Passport Copy',
		parents: [
			PageTypeEnum.APPLICANT,
			//PageTypeEnum.EXTENSION_STAY,
			PageTypeEnum.CHANGE_WORK_PLACE,
		],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_41,
		label: '한국어능력 입증자료',
		labelEn: 'Korean Language Proficiency Certificate',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_42,
		label: '언어소통 도우미 해외초청 사유서',
		labelEn: 'Invitation Letter for Overseas Language Helper',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_43,
		label: '사증발급신청서',
		labelEn: 'Visa Application Form',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_44,
		label: '건강진단서',
		labelEn: 'Health Certificate',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_45,
		label: '결핵진단서',
		labelEn: 'Tuberculosis Test Certificate',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_46,
		label: '범죄경력증명서',
		labelEn: 'Criminal Record Certificate',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_47,
		label: '여행자보험 가입 증명서',
		labelEn: 'Travel Insurance Certificate',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_48,
		label: '통합신청서(외국인 등록)',
		labelEn: 'Integrated Application Form (Foreigner Registration)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_49,
		label: '거주/숙소 제공 확인서',
		labelEn: 'Accommodation/Residence Confirmation Letter',
		parents: [
			PageTypeEnum.RECOMMENDER,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.LODGING,
			//PageTypeEnum.EXTENSION_STAY,
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.FRANCHISE,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_51,
		label: '외국인등록증',
		labelEn: 'Foreigner Registration Card',
		parents: [
			PageTypeEnum.APPLICANT,
			PageTypeEnum.CHANGE_WORK_PLACE,
			//PageTypeEnum.EXTENSION_STAY,
		],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_52,
		label: '계절근로자 재입국 추천 확인서',
		labelEn: 'Re-entry Recommendation Confirmation for Seasonal Worker',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_53,
		label: '인신매매 피해 식별지표',
		labelEn: 'Human Rights Violation Identification Indicators',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_54,
		label: '숙소점검 확인서',
		labelEn: 'Accommodation Inspection Certificate',
		parents: [
			PageTypeEnum.RECOMMENDER,
			PageTypeEnum.LODGING,
			PageTypeEnum.FRANCHISE,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_55,
		label: '표준근로계약서',
		labelEn: 'Standard Labor Contract',
		parents: [
			//PageTypeEnum.EXTENSION_STAY,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.APPLICANT,
		],
		hasDocument: true,
	},
	// {
	// 	value: DocumentTypeEnum.C_56,
	// 	label: '외국인 계절근로자(E-8) 체류기간 연장 추천 신청서(30일 ~ 60일 사이)',
	//	labelEn: 'Stay Extension Application for Seasonal Worker (E-8) (30~60 days)',
	// 	parents: [PageTypeEnum.EXTENSION_STAY],
	// 	hasDocument: false,
	// },
	// {
	// 	value: DocumentTypeEnum.C_57,
	// 	label: '체류기간 만료 계절근로자 체류기간 연장 추천서 (30일 이내)',
	//	labelEn: 'Stay Extension Recommendation for Expiring Seasonal Worker (within 30 days)',
	// 	parents: [PageTypeEnum.EXTENSION_STAY],
	// 	hasDocument: true,
	// },
	{
		value: DocumentTypeEnum.C_58,
		label: '통합신청서(체류연장)',
		labelEn: 'Integrated Application Form (Stay Extension)',
		parents: [
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
			// PageTypeEnum.EXTENSION_STAY
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_59,
		label: '고용변동신고서(근무처변경)',
		labelEn: 'Employment Change Report (Workplace Change)',
		parents: [
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.APPLICANT,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_60,
		label: '계절근로자 배치 대상 고용주 확인서 (외국인등록 후)',
		labelEn:
			'Confirmation of Employer for Seasonal Worker Placement (After Foreigner Registration)',
		parents: [PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_61,
		label: '통합신청서(근무처변경)',
		labelEn: 'Integrated Application Form (Workplace Change)',
		parents: [
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_62,
		label: '사진',
		labelEn: 'Image',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_63,
		label: '고용변동신고서(무단이탈)',
		labelEn: 'Employment Change Report (Unauthorized Leave)',
		parents: [
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.UNAUTHORIZED_DEPARTURE,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_64,
		label: '고용주 벌점 부과 확인서',
		labelEn: 'Employer Penalty Point Confirmation',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: false,
	},
	{
		value: DocumentTypeEnum.C_65,
		label: '지자체 벌점 부과 확인서',
		labelEn: 'Local Government Penalty Point Confirmation',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_66,
		label: '지자체 위반사항 주의서',
		labelEn: 'Local Government Violation Notice',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_67,
		label: '마약검사 확인서(법무부 지정 의료기관)',
		labelEn:
			'Drug Test Certificate (Medical Institution Designated by the Ministry of Justice)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_68,
		label: '마약검사 확인서(보건소 및 보건의료원)',
		labelEn: 'Drug Test Confirmation (Public Health Center/Clinic)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.CHANGE_WORK_PLACE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_69,
		label: '준수사항 위반 고용주 벌점 부과 기준',
		labelEn: 'Employer Penalty Criteria for Violation of Requirements',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_72,
		label: '개인정보 수집 및 이용 제공 동의',
		labelEn: 'Consent to Collect and Use Personal Information',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	// {
	// 	value: DocumentTypeEnum.C_73,
	// 	label: '고용주 별점 부과 확인서',
	// 	labelEn: 'Employer Violation Confirmation',
	// 	parents: [PageTypeEnum.FRANCHISE],
	// 	hasDocument: true,
	// },
	{
		value: DocumentTypeEnum.C_74,
		label: '계절근로 참여 신청서(유학생[D-2]의 부모)',
		labelEn:
			'Application for Participation in Seasonal Work (Parents of Foreign Students [D-2])',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.RECOMMENDER],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_75,
		label: '고용변동신고서(중도출국)',
		labelEn: 'Employment Change Report (Early Departure)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_76,
		label: '농업 안전관리 체크리스트[고용주용]',
		labelEn: 'Agricultural Safety Management Checklist [Employer]',
		parents: [PageTypeEnum.FRANCHISE, PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_77,
		label: '농업 안전관리 체크리스트[근로자용]',
		labelEn: 'Agricultural Safety Management Checklist [Worker]',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_78,
		label: '개인정보 수집 및 이용 제공 동의(의무보험용_계절근로자용)',
		labelEn: 'Applicant Privacy Consent (Mandatory Insurance)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		// DN(고용주) 관리 화면 vs NLĐ(계절근로자) 관리 화면에 따라 다르게 표시
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_79,
		label: '상해보험료 공제동의서',
		labelEn: 'Accident Insurance Deduction Consent',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_80,
		label: '임금체불 보증보험 가입 확약서',
		labelEn: 'Wage Arrears Insurance Commitment',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_81,
		label: '상해보험 가입 확약서',
		labelEn: 'Accident Insurance Commitment',
		parents: [PageTypeEnum.APPLICANT],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_82,
		label: '외국인 계절근로자 고용 신청서',
		labelEn:
			'Application for Foreign Seasonal Worker Employment (Municipal/County/District)',
		parents: [PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_83,
		label: '계절근로 참여 추천서(결혼이민자의 가족)',
		labelEn:
			'Recommendation for Seasonal Work Participation (Family of Marriage Immigrants)',
		parents: [
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.RECOMMENDER,
		],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_84,
		label: '개인정보 수집 및 이용 제공 동의(의무보험용_고용주용)',
		labelEn: 'Employer Privacy Consent (Mandatory Insurance)',
		parents: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		hasDocument: true,
	},
	{
		value: DocumentTypeEnum.C_0,
		label: '기타',
		labelEn: 'Others',
		parents: [
			PageTypeEnum.UNIT,
			PageTypeEnum.PROGRAM,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.RECOMMENDER,
			PageTypeEnum.FRANCHISE,
			PageTypeEnum.LODGING,
			//PageTypeEnum.EXTENSION_STAY,
			PageTypeEnum.CHANGE_WORK_PLACE,
			PageTypeEnum.UNAUTHORIZED_DEPARTURE,
		],

		hasDocument: false,
	},
];

export const ALL_ISSUANCE_APPLICATION_OPTION: (DefaultOptionType & {
	pageType: PageTypeEnum[];
})[] = [
	{
		// Program Attraction Application
		value: IssuanceApplicationEnum.IA1,
		label: '프로그램 유치 신청',
		pageType: [PageTypeEnum.UNIT, PageTypeEnum.PROGRAM],
		documents: {
			[PageTypeEnum.UNIT]: [
				DocumentTypeEnum.C_1,
				DocumentTypeEnum.C_2,
				DocumentTypeEnum.C_3,
				DocumentTypeEnum.C_4,
				DocumentTypeEnum.C_5,
				DocumentTypeEnum.C_7,
				DocumentTypeEnum.C_8,
				DocumentTypeEnum.C_9,
				DocumentTypeEnum.C_10,
				DocumentTypeEnum.C_0,
			],
			[PageTypeEnum.PROGRAM]: [
				DocumentTypeEnum.C_1,
				DocumentTypeEnum.C_2,
				DocumentTypeEnum.C_3,
				DocumentTypeEnum.C_4,
				DocumentTypeEnum.C_5,
				DocumentTypeEnum.C_7,
				DocumentTypeEnum.C_8,
				DocumentTypeEnum.C_9,
				DocumentTypeEnum.C_10,
				DocumentTypeEnum.C_0,
			],
		},
	},

	{
		// Application for participation in seasonal work (family/relatives of marriage immigrants)
		value: IssuanceApplicationEnum.IA2,
		label: '계절근로 참여 신청서(결혼이민자의 가족·친척)',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [DocumentTypeEnum.C_37],
		},
	},
	{
		// Application for visa issuance certificate
		value: IssuanceApplicationEnum.IA3,
		label: '사증발급인정서 신청',
		pageType: [
			// PageTypeEnum.UNIT,
			// PageTypeEnum.PROGRAM,
			PageTypeEnum.APPLICANT,
			PageTypeEnum.FRANCHISE,
		],
		documents: {
			// [PageTypeEnum.UNIT]: [
			// 	DocumentTypeEnum.C_1,
			// 	DocumentTypeEnum.C_2,
			// 	DocumentTypeEnum.C_3,
			// 	DocumentTypeEnum.C_4,
			// 	DocumentTypeEnum.C_5,
			// 	DocumentTypeEnum.C_9,
			// 	DocumentTypeEnum.C_10,
			// 	DocumentTypeEnum.C_0,
			// ],
			// [PageTypeEnum.PROGRAM]: [
			// 	DocumentTypeEnum.C_1,
			// 	DocumentTypeEnum.C_2,
			// 	DocumentTypeEnum.C_3,
			// 	DocumentTypeEnum.C_4,
			// 	DocumentTypeEnum.C_5,
			// 	DocumentTypeEnum.C_9,
			// 	DocumentTypeEnum.C_10,
			// 	DocumentTypeEnum.C_0,
			// ],
			[PageTypeEnum.FRANCHISE]: [
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_16,
				DocumentTypeEnum.C_76,
			],
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_16,
				DocumentTypeEnum.C_40,
				DocumentTypeEnum.C_39,
				DocumentTypeEnum.C_26,
				DocumentTypeEnum.C_27,
				DocumentTypeEnum.C_36,
				DocumentTypeEnum.C_28,
				DocumentTypeEnum.C_29,
				DocumentTypeEnum.C_30,
				DocumentTypeEnum.C_31,
				DocumentTypeEnum.C_32,
				DocumentTypeEnum.C_33,
				DocumentTypeEnum.C_34,
				DocumentTypeEnum.C_35,
				DocumentTypeEnum.C_0,
				DocumentTypeEnum.C_77,
			],
		},
	},
	{
		// Visa application
		value: IssuanceApplicationEnum.IA4,
		label: '사증 신청',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_43,
				DocumentTypeEnum.C_40,
				DocumentTypeEnum.C_62,
				DocumentTypeEnum.C_44,
				DocumentTypeEnum.C_45,
				DocumentTypeEnum.C_46,
			],
		},
	},
	{
		// (Re-entry) Application for visa issuance certificate
		value: IssuanceApplicationEnum.IA5,
		label: '(재입국)사증발급인정서 신청',
		pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_52,
				// DocumentTypeEnum.C_24,
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_40,
			],
			[PageTypeEnum.FRANCHISE]: [
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_52,
				// DocumentTypeEnum.C_24,
			],
		},
	},
	{
		// (Re-entry) visa application
		value: IssuanceApplicationEnum.IA6,
		label: '(재입국)사증 신청',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_43,
				DocumentTypeEnum.C_40,
				DocumentTypeEnum.C_62,
			],
		},
	},
	{
		// Application for Alien Registration
		value: IssuanceApplicationEnum.IA7,
		label: '외국인등록 신청',
		pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_48,
				DocumentTypeEnum.C_49,
				DocumentTypeEnum.C_40,
				DocumentTypeEnum.C_62,
				DocumentTypeEnum.C_47,
				DocumentTypeEnum.C_67,
				DocumentTypeEnum.C_68,
			],
			[PageTypeEnum.FRANCHISE]: [
				DocumentTypeEnum.C_54,
				DocumentTypeEnum.C_17,
				DocumentTypeEnum.C_18,
				DocumentTypeEnum.C_48,
				DocumentTypeEnum.C_49,
			],
		},
	},
	// {
	// 	// Extension of stay permit
	// 	value: IssuanceApplicationEnum.IA8,
	// 	label: '체류기간 연장허가',
	// 	pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
	// 	documents: {
	// 		[PageTypeEnum.APPLICANT]: [
	// 			DocumentTypeEnum.C_58,
	// 			DocumentTypeEnum.C_19,
	// 			DocumentTypeEnum.C_21,
	// 		],
	// 		[PageTypeEnum.FRANCHISE]: [DocumentTypeEnum.C_20, DocumentTypeEnum.C_58],
	// 	},
	// },
	{
		// Permission to change workplace
		value: IssuanceApplicationEnum.IA9,
		label: '근무처 변경허가',
		pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_61,
				DocumentTypeEnum.C_40,
				DocumentTypeEnum.C_62,
				DocumentTypeEnum.C_51,
				DocumentTypeEnum.C_59,
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_49,
			],
			[PageTypeEnum.FRANCHISE]: [
				DocumentTypeEnum.C_55,
				DocumentTypeEnum.C_49,
				DocumentTypeEnum.C_17,
				DocumentTypeEnum.C_18,
				DocumentTypeEnum.C_23,
				DocumentTypeEnum.C_14,
				DocumentTypeEnum.C_61,
			],
		},
	},
	{
		// Unauthorized departure
		value: IssuanceApplicationEnum.IA10,
		label: '무단이탈',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [DocumentTypeEnum.C_63],
		},
	},
	{
		// Worker Departure
		value: IssuanceApplicationEnum.IA11,
		label: '근로자 출국',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [DocumentTypeEnum.C_53],
		},
	},
	{
		// Consent to collection, use and provision of personal information
		value: IssuanceApplicationEnum.IA12,
		label: '개인정보 수집 및 이용 제공 동의',
		pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		documents: {
			[PageTypeEnum.APPLICANT]: [DocumentTypeEnum.C_72],
			[PageTypeEnum.FRANCHISE]: [DocumentTypeEnum.C_72],
		},
	},
	{
		//
		value: IssuanceApplicationEnum.IA13,
		label: '중도출국',
		pageType: [PageTypeEnum.APPLICANT],
		documents: {
			[PageTypeEnum.APPLICANT]: [DocumentTypeEnum.C_75],
		},
	},
	{
		//
		value: IssuanceApplicationEnum.IA14,
		label: '보험 관련 서류',
		pageType: [PageTypeEnum.APPLICANT, PageTypeEnum.FRANCHISE],
		documents: {
			[PageTypeEnum.APPLICANT]: [
				DocumentTypeEnum.C_78,
				DocumentTypeEnum.C_79,
				DocumentTypeEnum.C_81,
				DocumentTypeEnum.C_84,
			],
			[PageTypeEnum.FRANCHISE]: [
				DocumentTypeEnum.C_78,
				DocumentTypeEnum.C_79,
				DocumentTypeEnum.C_80,
				DocumentTypeEnum.C_84,
			],
		},
	},
];

export enum FileTypeEnum {
	UPLOAD = 'UPLOAD',
	FORM = 'FORM',
}

export enum FileTypeLabelEnum {
	UPLOAD = '업로드',
	FORM = '전자 문서',
}

export const FILE_TYPE_OPTIONS = [
	{
		value: FileTypeEnum.UPLOAD,
		label: FileTypeLabelEnum.UPLOAD,
	},
	{
		value: FileTypeEnum.FORM,
		label: FileTypeLabelEnum.FORM,
	},
];
